export enum TaskActivityType {
  CREATED = 'CREATED',
  UPDATED = 'UPDATED',
  UPDATED_STATUS = 'UPDATED_STATUS',
  ARCHIVED = 'ARCHIVED'
}